import styled from "styled-components";

export const ThinProgressBarContainerBox = styled.div<{isVisible: boolean}>`
    display: flex;
    align-items: center;
    width: 100%;
    height: 12px;
    overflow: hidden;
    position: relative;
    visibility: ${props => props.isVisible ? 'visible' : 'hidden'};
`;

